import { Box, LinearProgress } from '@mui/material'
import { EditorContent, JSONContent, useEditor } from '@tiptap/react'
import { FC } from 'react'
import { useDocMediaUpload } from '../../../hooks/useDocMediaUpload'
import { DOCS_LABELS } from '../docs.constants'
import { buildDocExtensions } from './editorExtensions'
import { EditorToolbar } from './EditorToolbar'
import { proseSx } from './editorStyles'

interface RichTextEditorProps {
  /** Owning page id — used to namespace uploaded media in S3. */
  pageId: string
  /** Initial document. Mount a fresh editor per page via `key={pageId}`. */
  content?: JSONContent | null
  onChange: (json: JSONContent) => void
}

/** Full WYSIWYG editor for authoring a doc page. */
export const RichTextEditor: FC<RichTextEditorProps> = ({ pageId, content, onChange }) => {
  const { uploadMedia, uploading } = useDocMediaUpload(pageId)

  const editor = useEditor({
    extensions: buildDocExtensions(DOCS_LABELS.EDITOR_PLACEHOLDER),
    content: content || '',
    onUpdate: ({ editor: instance }) => onChange(instance.getJSON()),
  })

  return (
    <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden', bgcolor: 'background.paper' }}>
      <EditorToolbar editor={editor} onUpload={uploadMedia} uploading={uploading} />
      {uploading && <LinearProgress />}
      <Box sx={{ ...proseSx, p: 2 }}>
        <EditorContent editor={editor} />
      </Box>
    </Box>
  )
}
